
require('./bootstrap');
import Vue from 'vue';

import VueMask from 'v-mask'
Vue.use(VueMask);
import ElementUI from 'element-ui';
import locale from "element-ui/lib/locale/lang/pt-br";
import 'element-ui/lib/theme-chalk/index.css';
import mixin from "./mixins";

import numeral from 'numeral';
numeral.locale('pt-br');

Vue.use(ElementUI, {
    locale
});


import VueCurrencyInput from 'vue-currency-input';

const pluginOptions = {
    globalOptions: {
        currency: 'BRL'
    }
};
Vue.use(VueCurrencyInput, pluginOptions);
Vue.mixin({
    methods: {
        route
    }
});

Vue.mixin(mixin);

import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue';
import PortalVue from 'portal-vue';

Vue.mixin({ methods: { route } });
Vue.use(InertiaPlugin);
Vue.use(PortalVue);

const app = document.getElementById('app');
import { InertiaProgress } from '@inertiajs/progress'
import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts';
import pareto from 'highcharts/modules/pareto';
import gridLight from "highcharts/themes/grid-light";
gridLight(Highcharts)
pareto(Highcharts)
Vue.use(HighchartsVue)
Vue.prototype._ = _
new Vue({
    render: (h) =>
        h(InertiaApp, {
            props: {
                initialPage: JSON.parse(app.dataset.page),
                resolveComponent: (name) => require(`./Pages/${name}`).default,
            },
        }),
}).$mount(app);
InertiaProgress.init()

